import Application from "./Application";
import common from "./common";
import PreloaderScene from "./scenes/PreloaderScene";
import Brim from "./brim";
import screenfull from "screenfull";

export default class Main {
    /**
     * @param {number} [width=1024]
     * @param {number} [height=768]
     */
    constructor(width = 1024, height = 768) {
        this._width = width;
        this._height = height;
        this._app = null;
        this._preloader = null;
        this._printLoadProgress = true;
    }

    init() {
        P3.assets.audioFileTypes = ["ogg", "mp3"];
        P3.settings.WARN_TEXTURE_DIVISIBLE_BY_2 = false;
        P3.audio.preloadAudio = true;
        P3.input.refocus = false;

        PIXI.settings.RETINA_PREFIX = /_(?=[^_]*$)(.+)x/;
        PIXI.settings.MIPMAP_TEXTURES = false;
        PIXI.settings.STRICT_TEXTURE_CACHE = true;

        PIXI.settings.SPRITE_MAX_TEXTURES = 8;

        //common.tracking = new P3.tracking.Tracking(new P3.tracking.TrackingModuleGTag('UA-160662228-1'));
        this._paused = false;
        this._mute = false;

        document.addEventListener('visibilitychange', () => {
            if (document.hidden) {
                // the page has been hidden
                this._mute = P3.audio.isMute;
                P3.audio.mute(true);
                this._paused = true;
                window.blur();
            } else {
                // the page has become visible
                P3.audio.mute(this._mute);
                this._paused = false;
                window.focus();
            }
        });

        typeof TweenMax !== "undefined" && (TweenMax.defaultOverwrite = "none");

        const options = {
            width: this._width,
            height: this._height,
            holderId: "game",
            portrait: false,
            rotateImageUrl: "./assets/images/rotate.jpg",
            rotateImageColor: "#000000",
            aspectRatioFillHeight: true
        };

        const view = new P3.View(options);
        view.signals.ready.once(function (canvas) {
            const options = {};
            options.view = canvas;
            options.transparent = false;
            options.antialias = true;
            options.preserveDrawingBuffer = false;
            options.resolution = 1;

            const stage = new PIXI.Container();
            common.stage = stage;

            P3.input.init(stage, canvas);

            //if (P3.utils.isCocoonJS()) {
            //stage.scale.x = window.innerHeight / this._height;
            //  stage.scale.y = window.innerHeight / this._height;
            //}

            var ua = window.navigator.userAgent;
            var isIE = /MSIE|Trident/.test(ua);

            let renderer;
            if (PIXI.Renderer) {
                if (isIE) {
                    renderer = new PIXI.CanvasRenderer(Object.assign(options, {
                        width: this._width, height: this._height
                    }));
                } else {
                    renderer = PIXI.autoDetectRenderer(Object.assign(options, {
                        width: this._width, height: this._height
                    }));
                }
            } else {
                renderer = !P3.utils.isCocoonJS() ?
                    PIXI.autoDetectRenderer(this._width, this._height, options) :
                    new PIXI.WebGLRenderer(window.innerWidth, window.innerHeight, options);
            }
            renderer.backgroundColor = 0x0;
            common.renderer = renderer;

            common.stage.addChild(P3.scene.view);

            const transitions = new PIXI.Container();
            common.stage.addChild(transitions);
            common.transitions = transitions;

            // deprecated
            //window.lasttweentime = 0;
            //window.tweendt = 0;


            PIXI.Ticker.shared.add((deltaTime) => {
                window.deltaTime = deltaTime / PIXI.settings.TARGET_FPMS / 1000;

                // deprecated
                //const currentTime = P3.utils.TWEEN.now();
                //window.tweendt = currentTime - window.lasttweentime;
                //window.lasttweentime = currentTime;

                if (!this._paused) {
                    P3.scene.update(window.deltaTime);
                    P3.input.update();

                    P3.utils.TWEEN.update();// comment this line out if you are using TweenMax

                    renderer.render(stage);
                }
            });

            if (PIXI.utils.isMobile.apple.device) {
                new Brim("assets/images/brim.jpg");
            }

            if (screenfull.isEnabled) {
            //    setTimeout(() => screenfull.request(), 200);
            }

            this.loadPreAssets();

        }, this);

        view.signals.resize.add(this.onCanvasResize, this);
        common.view = view;

        this.loadConfig(function () {
            view.init()
        }, this);    // we load the config before we do anything
    }

    loadConfig(callback, scope) {
        scope = scope || window;
        P3.assets.addFiles([{name: "config", url: "config" + ".json"}], "./");
        P3.assets.signals.complete.once(function () {
            common.config = P3.assets.json("config");
            callback && callback.call(scope);
        }, this);
        P3.assets.load();
    }

    loadPreAssets() {
        const files = [
            {name: "strings", url: "data/strings" + ".json"},
            {name: "preloader_1x", url: "images/preloader_1x" + ".json"},
            {name: "bg_preloader", url: "images/bg_preloader" + ".jpg"}
        ];
        if (files.length) {
            P3.assets.addFiles(files, "./assets/");
            P3.assets.signals.complete.once(this.loadAssets, this);
            P3.assets.load();
        } else {
            this.loadAssets();
        }
    }

    loadAssets() {

        common.strings = P3.assets.json("strings");

        const files = [
            //local
            {name: "title", url: "images/localization/title_" + (window.__language ? window.__language : common.config.language) + ".png"},
            //   {name: "logo", url: "images/localization/logo_game_title_en" + ".png"},
            //bg
            {name: "results_bg", url: "images/bg_end_screen" + ".jpg"},
            {name: "bg_drawing", url: "images/bg_drawing" + ".jpg"},
            {name: "bg_splash_screen", url: "images/bg_splash" + ".jpg"},
            //sheets
            {name: "splash_1x", url: "images/splash_1x" + ".json"},
            {name: "ui_1x", url: "images/ui_1x" + ".json"},
            {name: "bg_0_1x", url: "images/bg_0_1x" + ".json"},
            {name: "bg_1_1x", url: "images/bg_1_1x" + ".json"},
            {name: "bg_2_1x", url: "images/bg_2_1x" + ".json"},
            {name: "end_0_1x", url: "images/end_0_1x" + ".json"},
           // {name: "bg_3_1x", url: "images/bg_3_1x" + ".json"},
            //    {name: "monsters_1x", url: "images/monsters_1x" + ".json"},

            //data
            {name: "ghost_01_data", url: "data/ghost_1" + ".json"},
            {name: "ghost_02_data", url: "data/ghost_2" + ".json"},
            {name: "ghost_03_data", url: "data/ghost_3" + ".json"},
            {name: "ghost_04_data", url: "data/ghost_4" + ".json"},
            {name: "ghost_05_data", url: "data/ghost_5" + ".json"},
            {name: "ghost_06_data", url: "data/ghost_6" + ".json"},
            {name: "ghost_07_data", url: "data/ghost_7" + ".json"},
            {name: "ghost_08_data", url: "data/ghost_8" + ".json"},
            {name: "ghost_09_data", url: "data/ghost_9" + ".json"},
            {name: "ghost_10_data", url: "data/ghost_10" + ".json"},
            {name: "ghost_11_data", url: "data/ghost_11" + ".json"},

            //spine

            {name: 'ghost_01', url: 'spine/ghost_1' + '.json'},
            {name: 'ghost_01_path', url: 'spine/ghost_1_path' + '.json'},
            //
            // {name: 'ghost_01', url: 'spine/ghost_1' + '.json'},
            //{name: 'ghost_01_path', url: 'spine/ghost_1_path' + '.json'},

            {name: 'ghost_02', url: 'spine/ghost_2' + '.json'},
            {name: 'ghost_02_path', url: 'spine/ghost_2_path' + '.json'},

            {name: 'ghost_03', url: 'spine/ghost_3' + '.json'},
            {name: 'ghost_03_path', url: 'spine/ghost_3_path' + '.json'},

            {name: 'ghost_04', url: 'spine/ghost_4' + '.json'},
            {name: 'ghost_04_path', url: 'spine/ghost_4_path' + '.json'},

            {name: 'ghost_05', url: 'spine/ghost_5' + '.json'},
            {name: 'ghost_05_path', url: 'spine/ghost_5_path' + '.json'},

            {name: 'ghost_06', url: 'spine/ghost_6' + '.json'},
            {name: 'ghost_06_path', url: 'spine/ghost_6_path' + '.json'},

            {name: 'ghost_07', url: 'spine/ghost_7' + '.json'},
            {name: 'ghost_07_path', url: 'spine/ghost_7_path' + '.json'},

            {name: 'ghost_08', url: 'spine/ghost_8' + '.json'},
            {name: 'ghost_08_path', url: 'spine/ghost_8_path' + '.json'},

            {name: 'ghost_09', url: 'spine/ghost_9' + '.json'},
            {name: 'ghost_09_path', url: 'spine/ghost_9_path' + '.json'},

            {name: 'ghost_10', url: 'spine/ghost_10' + '.json'},
            {name: 'ghost_10_path', url: 'spine/ghost_10_path' + '.json'},

            {name: 'ghost_11', url: 'spine/ghost_11' + '.json'},
            {name: 'ghost_11_path', url: 'spine/ghost_11_path' + '.json'},

            {name: 'net', url: 'spine/trap_net' + '.json', metadata: {spineSkeletonScale: 0.25}},
            {name: 'scooby', url: 'spine/scooby' + '.json', metadata: {spineSkeletonScale: 0.25}},
            {name: 'shaggy', url: 'spine/shaggy' + '.json', metadata: {spineSkeletonScale: 0.25}},
            {name: 'coffin', url: 'spine/scooby_doo_coffin' + '.json', metadata: {spineSkeletonScale: 0.25}},

            //particles
            {name: "emitter_dust_puff_00", url: "particles/emitter_dust_puff_00" + ".json"},

            //audio
            {name: 'sfx_camera_flash_00', url: 'audio/sfx/sfx_camera_flash_00' + P3.assets.audioFileExt},
            {name: 'sfx_castle_door_burst_open', url: 'audio/sfx/sfx_castle_door_burst_open' + P3.assets.audioFileExt},
            {name: 'sfx_castle_exterior_loop', url: 'audio/sfx/sfx_castle_exterior_loop' + P3.assets.audioFileExt},
            {name: 'sfx_change_colour_fill_00', url: 'audio/sfx/sfx_change_colour_fill_00' + P3.assets.audioFileExt},
            //   {name: 'sfx_click', url: 'audio/sfx/sfx_click' + P3.assets.audioFileExt},
            {name: 'sfx_coffin_open', url: 'audio/sfx/sfx_coffin_open' + P3.assets.audioFileExt},
            {name: 'sfx_coffin_rattle', url: 'audio/sfx/sfx_coffin_rattle' + P3.assets.audioFileExt},
            {name: 'sfx_drawing_fill_00', url: 'audio/sfx/sfx_drawing_fill_00' + P3.assets.audioFileExt},
            {name: 'sfx_drawing_loop_00', url: 'audio/sfx/sfx_drawing_loop_00' + P3.assets.audioFileExt},
            {name: 'sfx_erase_item_00', url: 'audio/sfx/sfx_erase_item_00' + P3.assets.audioFileExt},
            {name: 'sfx_event_axe_drop_00', url: 'audio/sfx/sfx_event_axe_drop_00' + P3.assets.audioFileExt},
            {name: 'sfx_event_monster_appear_00', url: 'audio/sfx/sfx_event_monster_appear_00' + P3.assets.audioFileExt},
            {name: 'sfx_event_monster_appear_01', url: 'audio/sfx/sfx_event_monster_appear_01' + P3.assets.audioFileExt},
            {name: 'sfx_event_monster_appear_02', url: 'audio/sfx/sfx_event_monster_appear_02' + P3.assets.audioFileExt},
            {name: 'sfx_event_monster_appear_03', url: 'audio/sfx/sfx_event_monster_appear_03' + P3.assets.audioFileExt},
            {name: 'sfx_event_monster_appear_04', url: 'audio/sfx/sfx_event_monster_appear_04' + P3.assets.audioFileExt},
            {name: 'sfx_event_monster_appear_05', url: 'audio/sfx/sfx_event_monster_appear_05' + P3.assets.audioFileExt},
            {name: 'sfx_ghostly_background_00', url: 'audio/sfx/sfx_ghostly_background_00' + P3.assets.audioFileExt},
            {name: 'sfx_ghostly_background_01', url: 'audio/sfx/sfx_ghostly_background_01' + P3.assets.audioFileExt},
            {name: 'sfx_ghostly_background_02', url: 'audio/sfx/sfx_ghostly_background_02' + P3.assets.audioFileExt},
            {name: 'sfx_negative', url: 'audio/sfx/sfx_negative' + P3.assets.audioFileExt},
            {name: 'sfx_next_design_page_00', url: 'audio/sfx/sfx_next_design_page_00' + P3.assets.audioFileExt},
            {name: 'sfx_paint_appears_00', url: 'audio/sfx/sfx_paint_appears_00' + P3.assets.audioFileExt},
            {name: 'sfx_pickup_hand', url: 'audio/sfx/sfx_pickup_hand' + P3.assets.audioFileExt},
            {name: 'sfx_pickup_paintcan', url: 'audio/sfx/sfx_pickup_paintcan' + P3.assets.audioFileExt},
            {name: 'sfx_pickup_slime_00', url: 'audio/sfx/sfx_pickup_slime_00' + P3.assets.audioFileExt},
            {name: 'sfx_pickup_spider_00', url: 'audio/sfx/sfx_pickup_spider_00' + P3.assets.audioFileExt},
            {name: 'sfx_pickup_web', url: 'audio/sfx/sfx_pickup_web' + P3.assets.audioFileExt},
            {name: 'sfx_positive', url: 'audio/sfx/sfx_positive' + P3.assets.audioFileExt},
            //     {name: 'sfx_rollover', url: 'audio/sfx/sfx_rollover' + P3.assets.audioFileExt},
            {name: 'sfx_select_design_00', url: 'audio/sfx/sfx_select_design_00' + P3.assets.audioFileExt},
            {name: 'sfx_trap_capture', url: 'audio/sfx/sfx_trap_capture' + P3.assets.audioFileExt},
            {name: 'sfx_running_steps_loop_00', url: 'audio/sfx/sfx_running_steps_loop_00' + P3.assets.audioFileExt},

            {name: 'sfx_click', url: 'audio/sfx/sfx_ui_btn_press' + P3.assets.audioFileExt},
            {name: 'sfx_rollover', url: 'audio/sfx/sfx_ui_btn_rollover' + P3.assets.audioFileExt},

            {name: 'sfx_bats_loop_00', url: 'audio/sfx/sfx_bats_loop_00' + P3.assets.audioFileExt},

            // music
            {name: "music_drawing_loop_a_00", url: "audio/music/music_drawing_loop_a_00" + P3.assets.audioFileExt},
            {name: "music_drawing_loop_b_00", url: "audio/music/music_drawing_loop_b_00" + P3.assets.audioFileExt},
            {name: "music_drawing_loop_c_00", url: "audio/music/music_drawing_loop_c_00" + P3.assets.audioFileExt},
            {name: "music_drawing_loop_d_00", url: "audio/music/music_drawing_loop_d_00" + P3.assets.audioFileExt},

            {name: "music_drawing_loop_e_end_00", url: "audio/music/music_drawing_loop_e_end_00" + P3.assets.audioFileExt},

            {name: "music_ghost_a_chase_loop_00", url: "audio/music/music_ghost_a_chase_loop_00" + P3.assets.audioFileExt},
            {name: "music_ghost_a_chase_loop_01", url: "audio/music/music_ghost_a_chase_loop_01" + P3.assets.audioFileExt},

            {name: "music_ghost_a_end_sting_00", url: "audio/music/music_ghost_a_end_sting_00" + P3.assets.audioFileExt},
            {name: "music_ghost_a_reveal_sting_00", url: "audio/music/music_ghost_a_reveal_sting_00" + P3.assets.audioFileExt},
            {name: "music_ghost_b_chase_loop_00", url: "audio/music/music_ghost_b_chase_loop_00" + P3.assets.audioFileExt},
            {name: "music_ghost_b_end_sting_00", url: "audio/music/music_ghost_b_end_sting_00" + P3.assets.audioFileExt},
            {name: "music_ghost_b_reveal_sting_00", url: "audio/music/music_ghost_b_reveal_sting_00" + P3.assets.audioFileExt},
            {name: "music_ghost_generic_coffin_loop_00", url: "audio/music/music_ghost_generic_coffin_loop_00" + P3.assets.audioFileExt}
        ];

        if (files.length) {
            this._preloader = new PreloaderScene();
            P3.scene.show(this._preloader);

            P3.assets.addFiles(files, "./assets/");
            P3.assets.signals.progress.add(this.onLoadingProgress, this);
            P3.assets.signals.complete.once(this.onLoadingCompleted, this);
            P3.assets.load();
        } else {
            this.start();
        }
    }

    start() {
        this._app = new Application();
        this._app.init();
    }

    onLoadingProgress(event) {
        this._preloader && (this._preloader.loaded = event.progress / 100);
        this._printLoadProgress && console.log("loading:", Math.floor(event.progress));
    }

    onLoadingCompleted() {
        this._preloader && (this._preloader.loaded = 1);
        setTimeout(() => this.start(), 440);
    }

    onCanvasResize(correct) {
        if (correct) {
            common.renderer.resize(P3.View.width, P3.View.height);
            if (P3.scene) {
                P3.scene.resize();

                for (let i = 0; i < common.transitions.children.length; ++i) {
                    const transition = common.transitions.children[i];
                    transition.resize && transition.resize();
                }
            }
        }
    }
}
